<template>
  <form>
    <v-row class="py-0">
      <v-col class="py-0" cols="12" sm="12" md="11" lg="11">
        <detail :id="id" :creditCard="creditCard"></detail>
      </v-col>
      <v-col cols="12" sm="12" md="1">
        <v-row class="py-0 mb-2">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" v-on="on" @click="back">
                  <v-icon>
                    mdi-arrow-left
                  </v-icon>
                </v-btn>
              </template>
              <span>Back</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="py-0 mb-2">
          <v-col cols="12" class="py-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="blue-grey" dark v-on="on" @click="dialogAuditHistory = true">
                  <v-icon>mdi-history</v-icon>
                </v-btn>
              </template>
              <span>History</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dialog-audit-history
      :dialog="dialogAuditHistory"
      entity-type="CreditCard"
      :entity-id="id"
      @close="dialogAuditHistory = false"
    ></dialog-audit-history>
  </form>
</template>

<script>
import Detail from "./DetailCreditCard";
import DialogAuditHistory from "@/components/DialogAuditHistory.vue";

export default {
  name: "credit-card-view",
  components: {
    Detail,
    "dialog-audit-history": DialogAuditHistory,
  },
  props: {
    id: Number,
  },
  data: () => ({
    creditCard: {},
    dialogAuditHistory: false,
  }),
  methods: {
    async getCreditCard() {
      this.$store.commit("SET_LOADER", true);
      const response = await this.$store.dispatch("creditCard/getById", this.id);
      if (response.status === 200) {
        this.creditCard = response.data;
        this.$store.commit("SET_LOADER", false);
      }
    },
    back() {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.getCreditCard();
  },
};
</script>

<style></style>
